import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export { BACKEND_URL };
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileUrl = (fileId) =>
  `${API}/files/${fileId}?auth=${encodeURIComponent(localStorage.getItem("token") || "")}`;

export const sendChatAttachment = ({ file, filename, candidateId, text }) => {
  const fd = new FormData();
  fd.append("file", file, filename || file.name || "fichier");
  if (candidateId) fd.append("candidate_id", candidateId);
  if (text) fd.append("text", text);
  return api.post("/chat/attachments", fd, { headers: { "Content-Type": "multipart/form-data" } });
};

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
